import { Injectable } from "@angular/core";
import { TenantSettingsRepository } from "../domain/tenant-settings-repository";
import { TenantSettings } from "../domain/tenant-settings";
import { Subject } from "rxjs";
@Injectable()
export class TenantService {
  private tenantSettings: TenantSettings;
  tenantSettingsUpdated: Subject<void>;

  constructor(private tenantSettingsRepository: TenantSettingsRepository) {
    this.tenantSettingsUpdated = new Subject<void>();
  }
  ngOnDestroy() {
    this.tenantSettingsUpdated.complete();
  }

  init() {
    if (!this.tenantSettings) {
      this.tenantSettingsRepository.getTenantSettings().then((settings) => {
        this.tenantSettings = settings;
      });
    }
  }
  async getTenantSettings(): Promise<TenantSettings> {
    try {
      if (!this.tenantSettings) {
        this.tenantSettings =
          await this.tenantSettingsRepository.getTenantSettings();
      }
      return Promise.resolve(this.tenantSettings);
    } catch {
      return Promise.resolve(null);
    }
  }

  async setTenantSettings(tenantSettings: TenantSettings): Promise<boolean> {
    const updateResult =
      await this.tenantSettingsRepository.setTenantSettings(tenantSettings);
    if (updateResult) {
      this.tenantSettings = tenantSettings;
      this.tenantSettingsUpdated.next();
    }
    return Promise.resolve(updateResult);
  }
}
